export const weekOne = [
  {
    "name": "Kenney Thomas",
    "Sunday": "A - PDO",
    "Monday": "A - PDO",
    "Tuesday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "Wednesday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "Thursday": "AVAC",
    "Friday": "AVAC",
    "Saturday": "14:00 - 22:00 7.4hbtr2 LDDISP",
    "type": "leadFOH"
  },
  {
    "name": "Erika Garcia",
    "Sunday": "A",
    "Monday": "13:00 - 20:00 6.4hisla BARTD",
    "Tuesday": "A",
    "Wednesday": "13:00 - 20:00 6.4hisla BARTD",
    "Thursday": "13:00 - 20:00 6.4hisla BARTD",
    "Friday": "13:00 - 20:00 6.4hisla BARTD",
    "Saturday": "13:00 - 21:00 7.4hisla BARTD",
    "type": "bartender"
  },
  {
    "name": "Silvia V Lopez",
    "Sunday": "08:00 - 16:00 7.4h3brm STAATT",
    "Monday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "Tuesday": "09:30 - 17:30 7.4h3brm STAATT",
    "Wednesday": "09:30 - 17:30 7.4hneep STAATT",
    "Thursday": "09:30 - 17:30 7.4h3brm STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Jeanne M Quirus",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "09:00 - 17:00 7.4hhogs BARTD",
    "Wednesday": "09:00 - 17:00 7.4hhogs BARTD",
    "Thursday": "09:00 - 17:00 7.4hhogs BARTD",
    "Friday": "09:00 - 17:00 7.4hhogs BARTD",
    "Saturday": "14:00 - 22:00 7.4hhogs BARTD",
    "type": "bartender"
  },
  {
    "name": "Nicholas F Lozano",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "Wednesday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "Thursday": "12:00 - 20:00 7.4hmoes LDBRTN",
    "Friday": "12:00 - 20:00 7.4hmoes LDBRTN",
    "Saturday": "10:00 - 18:00 7.4hmull LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Delone D Reynolds",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Wednesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Thursday": "06:30 - 14:30 7.4h3brm LDBOH",
    "Friday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Saturday": "07:00 - 15:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Dayra M Gonzalez",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "09:00 - 17:00 7.4h3brm STAATT",
    "Wednesday": "N",
    "Thursday": "09:00 - 17:00 7.4h3brm STAATT",
    "Friday": "09:00 - 17:00 7.4h3brm STAATT",
    "Saturday": "08:00 - 16:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Katoncia L Holder",
    "Sunday": "13:00 - 19:00 6hmoes BARTD",
    "Monday": "10:00 - 17:00 6.4hmoes BARTD",
    "Tuesday": "13:00 - 20:00 6.4hduff BARTD",
    "Wednesday": "13:00 - 20:00 6.4hduff BARTD",
    "Thursday": "N",
    "Friday": "10:30 - 16:30 6hhogs BARTD",
    "Saturday": "N",
    "type": "bartender"
  },
  {
    "name": "Neeranut Iamnoi",
    "Sunday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "Monday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "Tuesday": "N - PDO",
    "Wednesday": "N - PDO",
    "Thursday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "Friday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "Saturday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Rachel M Podber",
    "Sunday": "10:00 - 18:00 7.4hduff LDBRTN",
    "Monday": "10:00 - 18:00 7.4hduff LDBRTN",
    "Tuesday": "10:00 - 18:00 7.4hduff LDBRTN",
    "Wednesday": "10:00 - 18:00 7.4hduff LDBRTN",
    "Thursday": "A",
    "Friday": "P: 12:30-23:00",
    "Saturday": "14:00 - 22:00 7.4hduff LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Berta E Kodner",
    "Sunday": "08:30 - 16:30 7.4hbtr1 STAATT",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "09:30 - 17:30 7.4h3brm STAATT",
    "Thursday": "09:00 - 18:00 8hfood TRNRCL  JTCN",
    "Friday": "09:30 - 17:30 7.4h3brm STAATT",
    "Saturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Rachel M Ruiz",
    "Sunday": "ARDO",
    "Monday": "ARDO",
    "Tuesday": "ARDO",
    "Wednesday": "AVAC",
    "Thursday": "AVAC",
    "Friday": "10:00 - 18:00 7.4hduff LDBRTN",
    "Saturday": "10:00 - 18:00 7.4hduff LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Stephanie Ruiz",
    "Sunday": "A",
    "Monday": "10:30 - 16:30 6hisla BARTD",
    "Tuesday": "14:00 - 20:00 6hisla BARTD",
    "Wednesday": "AVAC",
    "Thursday": "ARDO",
    "Friday": "10:30 - 16:30 6hisla BARTD",
    "Saturday": "12:00 - 20:00 7.4hisla BARTD",
    "type": "bartender"
  },
  {
    "name": "Gorbachev Lingad",
    "Sunday": "08:00 - 16:00 7.4hbtr2 LDDISP",
    "Monday": "09:30 - 17:30 7.4h3brm STAATT",
    "Tuesday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "Wednesday": "P: 05:00-23:00",
    "Thursday": "P: 05:00-23:00",
    "Friday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "Saturday": "14:00 - 22:00 7.4h3brm STAATT",
    "type": "leadFOH"
  },
  {
    "name": "Steven A Walker",
    "Sunday": "10:00 - 16:00 6hmull BARTD",
    "Monday": "10:00 - 16:00 6hmull BARTD",
    "Tuesday": "A",
    "Wednesday": "10:00 - 16:00 6hmull BARTD",
    "Thursday": "A",
    "Friday": "13:00 - 20:00 6.4hduff BARTD",
    "Saturday": "11:00 - 17:00 6hmoes BARTD",
    "type": "bartender"
  },
  {
    "name": "Danny A Cruz",
    "Sunday": "07:00 - 15:00 7.4h3brm COOKHP",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "N",
    "type": "cook"
  },
  {
    "name": "Raven A Douglass",
    "Sunday": "A",
    "Monday": "12:00 - 20:00 7.4hmoes LDBRTN",
    "Tuesday": "12:00 - 20:00 7.4hmoes LDBRTN",
    "Wednesday": "11:00 - 19:00 7.4hmull LDBRTN",
    "Thursday": "10:00 - 18:00 7.4hduff LDBRTN",
    "Friday": "A",
    "Saturday": "09:00 - 17:00 7.4hmoes LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Janee M Ervin",
    "Sunday": "A",
    "Monday": "AVAC",
    "Tuesday": "AVAC",
    "Wednesday": "AVAC",
    "Thursday": "AVAC",
    "Friday": "AVAC",
    "Saturday": "AVAC"
  },
  {
    "name": "Paige Miller",
    "Sunday": "11:00 - 19:00 7.4hmull LDBRTN",
    "Monday": "P: 13:30-04:00",
    "Tuesday": "11:00 - 19:00 7.4hmull LDBRTN",
    "Wednesday": "P: 13:30-04:00",
    "Thursday": "11:00 - 19:00 7.4hmull LDBRTN",
    "Friday": "11:00 - 19:00 7.4hmull LDBRTN",
    "Saturday": "12:30 - 20:30 7.4hmull LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Eric D Mulgannon",
    "Sunday": "11:00 - 20:00 8.4h3brm SSUPFD",
    "Monday": "ADNS",
    "Tuesday": "ADNS",
    "Wednesday": "ADNS",
    "Thursday": "ADNS",
    "Friday": "ADNS",
    "Saturday": "ADNS",
    "type": "standAtt"
  },
  {
    "name": "Jennifer Calzadilla",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Jose A Escobar",
    "Sunday": "12:00 - 20:00 7.4hmoes LDBRTN",
    "Monday": "11:00 - 19:00 7.4hmull LDBRTN",
    "Tuesday": "A",
    "Wednesday": "12:00 - 20:00 7.4hmoes LDBRTN",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "15:00 - 22:00 6.4hmoes LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Joseph L Velasco",
    "Sunday": "A - PDO",
    "Monday": "A - PDO",
    "Tuesday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "Wednesday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "Thursday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "Friday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "Saturday": "07:00 - 15:00 7.4hbtr1 LDRUN",
    "type": "runner"
  },
  {
    "name": "Abby E Aaronson",
    "Sunday": "07:00 - 15:00 7.4h3brm PREP",
    "Monday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Tuesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Wednesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "07:00 - 15:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Guillermo A Lino",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "10:00 - 17:00 6.4hmoes BARTD",
    "Wednesday": "10:00 - 17:00 6.4hmoes BARTD",
    "Thursday": "10:00 - 16:00 6hmull BARTD",
    "Friday": "P: 10:00-21:00",
    "Saturday": "14:00 - 20:00 6hmoes BARTD",
    "type": "bartender"
  },
  {
    "name": "Julio C Aceves",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "07:00 - 15:00 7.4h3brm PREP",
    "Wednesday": "07:00 - 15:00 7.4h3brm PREP",
    "Thursday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Friday": "07:00 - 15:00 7.4h3brm PREP",
    "Saturday": "N",
    "type": "cook"
  },
  {
    "name": "Larry Gunter",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "P: 09:00-22:00",
    "Friday": "P: 09:00-22:00",
    "Saturday": "10:30 - 16:30 6hmull BARTD",
    "type": "bartender"
  },
  {
    "name": "Shawna E Foster",
    "Sunday": "13:00 - 20:00 6.4hduff BARTD",
    "Monday": "13:00 - 20:00 6.4hduff BARTD",
    "Tuesday": "10:00 - 16:00 6hmull BARTD",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "A",
    "Saturday": "10:30 - 18:30 7.4hhogs BARTD",
    "type": "bartender"
  },
  {
    "name": "April A Lovins",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "07:00 - 15:00 7.4h3brm PREP",
    "Wednesday": "07:00 - 15:00 7.4h3brm PREP",
    "Thursday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Friday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Saturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Venus V Marcial",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A - PDO",
    "Friday": "A - PDO",
    "Saturday": "A"
  },
  {
    "name": "Cristian Gutierrez",
    "Sunday": "07:00 - 15:00 7.4hbtr1 FDRUN",
    "Monday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "Tuesday": "11:00 - 19:00 7.4hbtr1 FDRUN",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "P: 06:00-20:00VAC",
    "Saturday": "P: 06:00-20:00VAC",
    "type": "runner"
  },
  {
    "name": "Giuseppe Restreppo",
    "Sunday": "N",
    "Monday": "A",
    "Tuesday": "N",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Isaac Garcia",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Wednesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Thursday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Friday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Saturday": "07:30 - 15:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Pernell E Sims",
    "Sunday": "N",
    "Monday": "P: 10:00-22:00",
    "Tuesday": "P: 10:00-22:00",
    "Wednesday": "A",
    "Thursday": "P: 10:00-22:00",
    "Friday": "P: 10:00-22:00",
    "Saturday": "A"
  },
  {
    "name": "Briana R Amlin",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Jesus Cortez",
    "Sunday": "12:30 - 20:30 7.4hbtr1 FDRUN",
    "Monday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Tuesday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "Wednesday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "Thursday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "Friday": "N",
    "Saturday": "N",
    "type": "runner"
  },
  {
    "name": "Ariel Hernandez",
    "Sunday": "07:00 - 15:00 7.4hbtr1 LDRUN",
    "Monday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "Tuesday": "N",
    "Wednesday": "12:00 - 20:00 7.4hbtr1 LDRUN",
    "Thursday": "N",
    "Friday": "12:00 - 20:00 7.4hbtr1 LDRUN",
    "Saturday": "14:30 - 22:30 7.4hbtr1 LDRUN",
    "type": "runner"
  },
  {
    "name": "Dominiq Montano",
    "Sunday": "N",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Carrie L Baty",
    "Sunday": "08:00 - 16:00 7.4h3brm LDFOH",
    "Monday": "09:00 - 17:00 7.4h3brm LDFOH",
    "Tuesday": "09:00 - 17:00 7.4h3brm LDFOH",
    "Wednesday": "A - PDO",
    "Thursday": "A - PDO",
    "Friday": "12:00 - 20:00 7.4h3brm LDFOH",
    "Saturday": "14:00 - 22:00 7.4h3brm LDFOH",
    "type": "leadFOH"
  },
  {
    "name": "Cristian Valdivia",
    "Sunday": "09:00 - 17:00 7.4hbtr1 FDRUN",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Thursday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Friday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Saturday": "10:30 - 18:30 7.4hbtr1 FDRUN",
    "type": "runner"
  },
  {
    "name": "Al-Tariq N Taylor",
    "Sunday": "N",
    "Monday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Tuesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Wednesday": "N",
    "Thursday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Friday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Saturday": "07:30 - 15:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Rafael Hernandez Lomeli",
    "Sunday": "N",
    "Monday": "07:00 - 15:00 7.4h3brm PREP",
    "Tuesday": "07:00 - 15:00 7.4h3brm PREP",
    "Wednesday": "07:00 - 15:00 7.4h3brm PREP",
    "Thursday": "07:00 - 15:00 7.4h3brm PREP",
    "Friday": "07:00 - 15:00 7.4h3brm PREP",
    "Saturday": "N",
    "type": "cook"
  },
  {
    "name": "Oscar J Benitez",
    "Sunday": "08:30 - 16:30 7.4hneep STAATT",
    "Monday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Tuesday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "Saturday": "07:00 - 15:00 7.4hbtr1 FDRUN",
    "type": "standAtt"
  },
  {
    "name": "Esmeralda Campos",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "10:00 - 16:00 6hbtr1 STAATT",
    "Wednesday": "09:00 - 17:00 7.4h3brm STAATT",
    "Thursday": "10:30 - 16:30 6h3brm STAATT",
    "Friday": "10:30 - 16:30 6hbtr1 STAATT",
    "Saturday": "08:30 - 16:30 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michael A Gonzalez",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Wednesday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "Thursday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "Friday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "Saturday": "11:00 - 19:00 7.4hbtr1 FDRUN",
    "type": "runner"
  },
  {
    "name": "Jose O Pastrana Miranda",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "Wednesday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "Thursday": "10:00 - 18:00 7.4h3brm STAATT",
    "Friday": "10:00 - 18:00 7.4h3brm STAATT",
    "Saturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "John Rivera",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Wednesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Thursday": "10:30 - 18:30 7.4h3brm STAATT",
    "Friday": "10:00 - 18:00 7.4h3brm STAATT",
    "Saturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Carly L Alanis De La Cruz",
    "Sunday": "09:30 - 17:30 7.4h3brm STAATT",
    "Monday": "N",
    "Tuesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Wednesday": "N",
    "Thursday": "10:00 - 18:00 7.4h3brm STAATT",
    "Friday": "10:00 - 18:00 7.4h3brm STAATT",
    "Saturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Julian A Manzano",
    "Sunday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "Monday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "Tuesday": "11:00 - 19:00 7.4hneep STAATT",
    "Wednesday": "A",
    "Thursday": "A - PDO",
    "Friday": "10:00 - 18:00 7.4h3brm STAATT",
    "Saturday": "11:00 - 19:00 7.4hbtr2 LDDISP",
    "type": "leadFOH"
  },
  {
    "name": "Cecillia S Williams",
    "Sunday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "Monday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "Tuesday": "A - PDO",
    "Wednesday": "A - PDO",
    "Thursday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "Friday": "10:30 - 18:30 7.4h3brm STAATT",
    "Saturday": "14:00 - 22:00 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jake H Evans",
    "Sunday": "10:30 - 18:30 7.4h3brm COOKHP",
    "Monday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Friday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Saturday": "10:00 - 18:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Daphneanne Lindley",
    "Sunday": "06:30 - 14:30 7.4h3brm LDBOH",
    "Monday": "06:30 - 14:30 7.4h3brm LDBOH",
    "Tuesday": "06:30 - 14:30 7.4h3brm LDBOH",
    "Wednesday": "A",
    "Thursday": "A - PDO",
    "Friday": "07:00 - 15:00 7.4h3brm LDBOH",
    "Saturday": "07:00 - 15:00 7.4h3brm LDBOH",
    "type": "leadBOH"
  },
  {
    "name": "Dannell A Smith",
    "Sunday": "N",
    "Monday": "07:00 - 15:00 7.4h3brm PREP",
    "Tuesday": "07:00 - 15:00 7.4h3brm PREP",
    "Wednesday": "07:00 - 15:00 7.4h3brm PREP",
    "Thursday": "07:00 - 15:00 7.4h3brm PREP",
    "Friday": "07:00 - 15:00 7.4h3brm PREP",
    "Saturday": "N",
    "type": "cook"
  },
  {
    "name": "Christopher S Heang",
    "Sunday": "N",
    "Monday": "10:00 - 16:00 6hbtr2 STAATT",
    "Tuesday": "09:30 - 15:30 6h3brm STAATT",
    "Wednesday": "10:00 - 16:00 6hbtr2 STAATT",
    "Thursday": "10:00 - 16:00 6hbtr2 STAATT",
    "Friday": "10:00 - 16:00 6hbtr2 STAATT",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Sandy M Molina Cruz",
    "Sunday": "12:30 - 20:30 7.4hbtr1 FDRUN",
    "Monday": "10:30 - 18:30 7.4h3brm STAATT",
    "Tuesday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "Wednesday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "Thursday": "10:30 - 18:30 7.4h3brm STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "runner"
  },
  {
    "name": "Liliana Rosales Rodriguez",
    "Sunday": "P: 05:00-17:30RDO",
    "Monday": "09:30 - 17:30 7.4h3brm STAATT",
    "Tuesday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "Wednesday": "09:30 - 17:30 7.4h3brm STAATT",
    "Thursday": "09:30 - 17:30 7.4hneep STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Tony L Thompson Jr.",
    "Sunday": "09:30 - 17:30 7.4h3brm STAATT",
    "Monday": "10:00 - 18:00 7.4h3brm STAATT",
    "Tuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "10:30 - 18:30 7.4h3brm STAATT",
    "Saturday": "10:30 - 18:30 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Cristian Villa Trinidad",
    "Sunday": "09:30 - 17:30 7.4h3brm STAATT",
    "Monday": "N - PDO",
    "Tuesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Wednesday": "N - PDO",
    "Thursday": "10:00 - 18:00 7.4h3brm STAATT",
    "Friday": "09:30 - 17:30 7.4hneep STAATT",
    "Saturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Marisa Avitia",
    "Sunday": "09:30 - 17:30 7.4h3brm STAATT",
    "Monday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "Tuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Wednesday": "11:00 - 19:00 7.4hneep STAATT",
    "Thursday": "10:00 - 18:00 7.4h3brm STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Mary Campbell",
    "Sunday": "A - PDO",
    "Monday": "11:30 - 19:30 7.4h3brm STAATT",
    "Tuesday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "Wednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Thursday": "10:30 - 18:30 7.4h3brm STAATT",
    "Friday": "A - PDO",
    "Saturday": "11:30 - 19:30 7.4hvend STAATT",
    "type": "standAtt"
  },
  {
    "name": "Felicia K Tomiyasu-Gravante",
    "Sunday": "N",
    "Monday": "NVAC",
    "Tuesday": "NVAC",
    "Wednesday": "P: 05:00-17:00VAC",
    "Thursday": "NVAC",
    "Friday": "NVAC",
    "Saturday": "N"
  },
  {
    "name": "Efren Ceccaldi",
    "Sunday": "12:00 - 20:00 7.4h3brm LDBOH",
    "Monday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Tuesday": "12:00 - 20:00 7.4h3brm LDBOH",
    "Wednesday": "06:30 - 14:30 7.4h3brm LDBOH",
    "Thursday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Friday": "A",
    "Saturday": "A",
    "type": "leadBOH"
  },
  {
    "name": "Jacqueline Cortes",
    "Sunday": "07:30 - 15:30 7.4h3brm COOKHP",
    "Monday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Saturday": "07:30 - 15:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Dominic Aguas",
    "Sunday": "A - PDO",
    "Monday": "A - PDO",
    "Tuesday": "12:00 - 20:00 7.4h3brm LDFOH",
    "Wednesday": "12:00 - 20:00 7.4h3brm LDFOH",
    "Thursday": "09:00 - 17:00 7.4h3brm LDFOH",
    "Friday": "09:00 - 17:00 7.4h3brm LDFOH",
    "Saturday": "08:00 - 16:00 7.4hbtr2 LDDISP",
    "type": "leadFOH"
  },
  {
    "name": "Liliana Aguilar Fuentes",
    "Sunday": "09:00 - 15:00 6hbtr2 STAATT",
    "Monday": "N",
    "Tuesday": "10:00 - 16:00 6h3brm STAATT",
    "Wednesday": "N",
    "Thursday": "10:00 - 16:00 6hbtr1 STAATT",
    "Friday": "10:00 - 16:00 6hbtr1 STAATT",
    "Saturday": "08:00 - 14:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Keion Drummond",
    "Sunday": "12:00 - 20:00 7.4h3brm STAATT",
    "Monday": "10:30 - 18:30 7.4h3brm STAATT",
    "Tuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Wednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Thursday": "12:00 - 20:00 7.4h3brm STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Mark A Gutierrez",
    "Sunday": "11:00 - 19:00 7.4hneep STAATT",
    "Monday": "10:30 - 18:30 7.4h3brm STAATT",
    "Tuesday": "12:00 - 20:00 7.4h3brm STAATT",
    "Wednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "12:00 - 20:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Marco A Lopez Jr.",
    "Sunday": "P: 09:00-22:00VAC",
    "Monday": "P: 09:00-22:00VAC",
    "Tuesday": "P: 09:00-22:00VAC",
    "Wednesday": "P: 09:00-22:00VAC",
    "Thursday": "P: 09:00-22:00VAC",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Haisy Gomez",
    "Sunday": "09:30 - 17:30 7.4h3brm STAATT",
    "Monday": "10:30 - 16:30 6h3brm STAATT",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "10:30 - 18:30 7.4h3brm STAATT",
    "Friday": "P: 10:30-20:00VAC",
    "Saturday": "P: 05:00-19:00VAC",
    "type": "standAtt"
  },
  {
    "name": "Rachid F Frihi",
    "Sunday": "11:30 - 19:30 7.4h3brm STAATT",
    "Monday": "10:30 - 18:30 7.4h3brm STAATT",
    "Tuesday": "11:00 - 19:00 7.4h3brm STAATT",
    "Wednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "Thursday": "11:00 - 19:00 7.4hneep STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Abrahan Luna",
    "Sunday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "Monday": "12:00 - 20:00 7.4h3brm STAATT",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "Friday": "10:30 - 18:30 7.4h3brm STAATT",
    "Saturday": "14:30 - 22:30 7.4hbtr1 FDRUN",
    "type": "standAtt"
  },
  {
    "name": "Arlene Manilla",
    "Sunday": "08:30 - 14:30 6h3brm STAATT",
    "Monday": "10:00 - 18:00 7.4h3brm STAATT",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "P: 07:00-18:00",
    "Friday": "10:30 - 18:00 6.9hbtr2 STAATT",
    "Saturday": "09:00 - 17:00 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "David E Lobo",
    "Sunday": "A - PDO",
    "Monday": "A - PDO",
    "Tuesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Wednesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Thursday": "12:00 - 20:00 7.4h3brm LDBOH",
    "Friday": "10:00 - 18:00 7.4h3brm LDPREP",
    "Saturday": "10:00 - 18:00 7.4h3brm LDPREP",
    "type": "cook"
  },
  {
    "name": "David Mendoza",
    "Sunday": "07:30 - 15:30 7.4h3brm COOKHP",
    "Monday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Tuesday": "11:00 - 19:00 7.4h3brm COOKHP",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "08:00 - 16:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Robint R Rodriguez",
    "Sunday": "07:30 - 15:30 7.4h3brm COOKHP",
    "Monday": "07:00 - 15:00 7.4h3brm PREP",
    "Tuesday": "P: 06:00-16:00",
    "Wednesday": "N",
    "Thursday": "07:00 - 15:00 7.4h3brm PREP",
    "Friday": "07:00 - 15:00 7.4h3brm PREP",
    "Saturday": "08:00 - 16:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Lurleen N Frazier",
    "Sunday": "11:30 - 19:30 7.4h3brm STAATT",
    "Monday": "N",
    "Tuesday": "11:30 - 19:30 7.4h3brm STAATT",
    "Wednesday": "N",
    "Thursday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "Friday": "11:00 - 19:00 7.4hneep STAATT",
    "Saturday": "14:00 - 22:00 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Raul Ramirez",
    "Sunday": "10:00 - 18:00 7.4hbtr1 STAATT",
    "Monday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "Tuesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Wednesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Thursday": "A - PDO",
    "Friday": "N",
    "Saturday": "10:00 - 18:00 7.4hvend STAATT",
    "type": "standAtt"
  },
  {
    "name": "Kassandra Sanchez",
    "Sunday": "12:00 - 20:00 7.4h3brm LDFOH",
    "Monday": "12:00 - 20:00 7.4h3brm LDFOH",
    "Tuesday": "A - PDO",
    "Wednesday": "12:00 - 20:00 7.4h3brm STAATT",
    "Thursday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "Friday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "Saturday": "ARDO",
    "type": "leadFOH"
  },
  {
    "name": "Alicia A Cohen",
    "Sunday": "A - PDO",
    "Monday": "P: 06:00-19:00",
    "Tuesday": "P: 06:00-19:00",
    "Wednesday": "P: 06:00-19:00",
    "Thursday": "P: 06:00-19:00",
    "Friday": "A - PDO",
    "Saturday": "N"
  },
  {
    "name": "Megan N Hillyer",
    "Sunday": "11:30 - 19:30 7.4h3brm STAATT",
    "Monday": "11:00 - 19:00 7.4hneep STAATT",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "Friday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "Saturday": "14:00 - 22:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Kimberly A Lopez",
    "Sunday": "08:30 - 16:30 7.4hbtr2 STAATT",
    "Monday": "09:00 - 17:00 7.4h3brm STAATT",
    "Tuesday": "P: 06:00-17:00",
    "Wednesday": "P: 06:00-17:00",
    "Thursday": "10:30 - 16:30 6h3brm STAATT",
    "Friday": "11:00 - 17:00 6h3brm STAATT",
    "Saturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Sharon Ortega",
    "Sunday": "09:30 - 17:30 7.4hvend STAATT",
    "Monday": "10:00 - 18:00 7.4h3brm STAATT",
    "Tuesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Wednesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Thursday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Mark A Trevizo",
    "Sunday": "10:30 - 18:30 7.4h3brm COOKHP",
    "Monday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Friday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Saturday": "10:30 - 18:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Guadalupe I Cornejo",
    "Sunday": "11:30 - 19:30 7.4h3brm STAATT",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "Thursday": "11:30 - 19:30 7.4h3brm STAATT",
    "Friday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "Saturday": "11:30 - 19:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "John R Aguila",
    "Sunday": "ASCK",
    "Monday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Tuesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Wednesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Thursday": "07:00 - 15:00 7.4h3brm PREP",
    "Friday": "A",
    "Saturday": "A",
    "type": "cook"
  },
  {
    "name": "Christopher D Wilson",
    "Sunday": "07:00 - 15:00 7.4h3brm COOKHP",
    "Monday": "P: 07:00-19:00",
    "Tuesday": "P: 07:00-19:00",
    "Wednesday": "11:00 - 19:00 7.4h3brm COOKHP",
    "Thursday": "11:00 - 19:00 7.4h3brm COOKHP",
    "Friday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Saturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Vanessa D Rodriguez",
    "Sunday": "12:00 - 20:00 7.4h3brm COOKHP",
    "Monday": "P: 04:00-20:00",
    "Tuesday": "P: 04:00-17:00",
    "Wednesday": "P: 04:00-20:00",
    "Thursday": "P: 04:00-20:00",
    "Friday": "P: 04:00-17:00",
    "Saturday": "P: 04:00-20:00RDO",
    "type": "cook"
  },
  {
    "name": "Natalya A Galarza",
    "Sunday": "P: 06:00-16:00",
    "Monday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "Tuesday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "Wednesday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "Thursday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "Friday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "Saturday": "P: 06:00-16:00"
  },
  {
    "name": "Shaun Loeser",
    "Sunday": "A - PDO",
    "Monday": "A - PDO",
    "Tuesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Wednesday": "09:30 - 18:12 8hfood TRNRCL  JTFD",
    "Thursday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Friday": "12:00 - 20:00 7.4h3brm LDBOH",
    "Saturday": "14:00 - 22:00 7.4h3brm LDBOH",
    "type": "cook"
  },
  {
    "name": "Samer G Nassar",
    "Sunday": "12:00 - 20:00 7.4h3brm STAATT",
    "Monday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "Tuesday": "A",
    "Wednesday": "09:00 - 17:00 7.4h3brm LDFOH",
    "Thursday": "A",
    "Friday": "12:00 - 20:00 7.4h3brm STAATT",
    "Saturday": "11:00 - 19:00 7.4h3brm LDFOH",
    "type": "standAtt"
  },
  {
    "name": "Louis T Cooley",
    "Sunday": "07:00 - 15:00 7.4h3brm PREP",
    "Monday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Friday": "07:00 - 15:00 7.4h3brm PREP",
    "Saturday": "11:00 - 19:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Robert Dunne",
    "Sunday": "07:00 - 15:00 7.4h3brm PREP",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Thursday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Friday": "11:00 - 19:00 7.4h3brm COOKHP",
    "Saturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Kirsten Labrador",
    "Sunday": "07:00 - 15:00 7.4h3brm PREP",
    "Monday": "11:00 - 19:00 7.4h3brm COOKHP",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "P: 06:00-19:00",
    "Friday": "07:00 - 15:00 7.4h3brm PREP",
    "Saturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Kevon J Taite",
    "Sunday": "10:30 - 18:30 7.4h3brm COOKHP",
    "Monday": "A",
    "Tuesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Wednesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Thursday": "A",
    "Friday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Saturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Regan C Danner",
    "Sunday": "A - PDO",
    "Monday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "Tuesday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "Wednesday": "11:30 - 19:30 7.4h3brm STAATT",
    "Thursday": "12:00 - 20:00 7.4h3brm LDFOH",
    "Friday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "Saturday": "A",
    "type": "standAtt"
  },
  {
    "name": "David Munoz",
    "Sunday": "11:00 - 19:00 7.4h3brm COOKHP",
    "Monday": "12:00 - 20:00 7.4h3brm LDBOH",
    "Tuesday": "A",
    "Wednesday": "12:00 - 20:00 7.4h3brm LDBOH",
    "Thursday": "A - PDO",
    "Friday": "N",
    "Saturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Garry S Walton Jr",
    "Sunday": "11:00 - 19:00 7.4h3brm COOKHP",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Thursday": "A",
    "Friday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Saturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Agustin Macias",
    "Sunday": "12:00 - 20:00 7.4h3brm COOKHP",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A - PDO",
    "Thursday": "A - PDO",
    "Friday": "11:30 - 19:30 7.4h3brm COOKHP",
    "Saturday": "10:30 - 18:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Morgan B Beattie",
    "Sunday": "P: 10:00-23:30RDO",
    "Monday": "P: 10:00-23:30RDO",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "P: 10:00-23:30VAC",
    "Friday": "P: 10:00-23:30VAC",
    "Saturday": "P: 10:00-23:30VAC"
  },
  {
    "name": "Eduardo Hernandez",
    "Sunday": "12:00 - 20:00 7.4h3brm COOKHP",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "A",
    "Saturday": "11:00 - 19:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Andrew Thareererg",
    "Sunday": "12:00 - 20:00 7.4h3brm COOKHP",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "11:30 - 19:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Erik A Pinto",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Kathryn E Anderson",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "P: 07:00-18:00",
    "Wednesday": "P: 07:00-18:00",
    "Thursday": "P: 07:00-18:00",
    "Friday": "P: 07:00-18:00",
    "Saturday": "P: 07:00-18:00RDO"
  },
  {
    "name": "Alexandra M Varley",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "ARDO",
    "Friday": "ARDO",
    "Saturday": "ARDO"
  },
  {
    "name": "Eric D Jewell",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "Friday": "A",
    "Saturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "leadFOH"
  },
  {
    "name": "Janet G Cuevas",
    "Sunday": "07:00 - 15:00 7.4h3brm COOKHP",
    "Monday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Tuesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Wednesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Thursday": "N",
    "Friday": "P: 04:00-15:00",
    "Saturday": "07:00 - 15:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Debbie G Otzoy",
    "Sunday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Monday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Tuesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Wednesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "Thursday": "08:00 - 16:00 7.4h3brm COOKHP",
    "Friday": "N",
    "Saturday": "N",
    "type": "cook"
  },
  {
    "name": "Teri Chase",
    "Sunday": "08:30 - 16:00 6.9h3brm STAATT",
    "Monday": "10:30 - 16:30 6h3brm STAATT",
    "Tuesday": "10:30 - 16:30 6hbtr1 STAATT",
    "Wednesday": "10:30 - 16:30 6hbtr1 STAATT",
    "Thursday": "11:00 - 17:00 6hbtr1 STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Jessica Morga",
    "Sunday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "Monday": "N",
    "Tuesday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "Wednesday": "N",
    "Thursday": "10:30 - 18:00 6.9hbtr2 STAATT",
    "Friday": "N",
    "Saturday": "11:30 - 19:30 7.4hneep STAATT",
    "type": "standAtt"
  },
  {
    "name": "Kyle Rietta",
    "Sunday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "12:00 - 20:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Gina M Cruz-Rolon",
    "Sunday": "10:30 - 16:30 6hhogs BARTD",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "A",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "A",
    "type": "bartender"
  },
  {
    "name": "Giselle Aleman",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "09:30 - 17:30 7.4h3brm STAATT",
    "Wednesday": "N",
    "Thursday": "11:00 - 17:00 6h3brm STAATT",
    "Friday": "09:30 - 17:30 7.4h3brm STAATT",
    "Saturday": "08:30 - 14:30 6hneep STAATT",
    "type": "standAtt"
  },
  {
    "name": "Irving Becerra",
    "Sunday": "09:30 - 17:30 7.4h3brm STAATT",
    "Monday": "09:30 - 17:30 7.4hneep STAATT",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "Friday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "Saturday": "11:00 - 19:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Georgina M Garcia",
    "Sunday": "P: 05:00-18:00",
    "Monday": "N",
    "Tuesday": "P: 05:00-18:00",
    "Wednesday": "P: 05:00-18:00",
    "Thursday": "P: 05:00-18:00",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Frank J Ojeda",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "09:30 - 17:30 7.4hneep STAATT",
    "Wednesday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "Thursday": "09:30 - 17:30 7.4h3brm STAATT",
    "Friday": "11:30 - 19:30 7.4h3brm STAATT",
    "Saturday": "11:00 - 19:00 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Matthew A Serna",
    "Sunday": "08:30 - 16:00 6.9h3brm STAATT",
    "Monday": "10:30 - 16:30 6hbtr1 STAATT",
    "Tuesday": "10:00 - 16:00 6hbtr2 STAATT",
    "Wednesday": "11:00 - 17:00 6hbtr1 STAATT",
    "Thursday": "11:00 - 17:00 6h3brm STAATT",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Saul M Aldana",
    "Sunday": "08:30 - 16:00 6.9h3brm STAATT",
    "Monday": "10:00 - 16:00 6hbtr1 STAATT",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "10:00 - 16:00 6hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michael R Harris",
    "Sunday": "09:30 - 17:30 7.4h3brm STAATT",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "14:00 - 22:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Matthew Illingworth",
    "Sunday": "N",
    "Monday": "11:00 - 17:00 6hbtr1 STAATT",
    "Tuesday": "P: 06:00-17:00",
    "Wednesday": "11:00 - 17:00 6h3brm STAATT",
    "Thursday": "10:30 - 16:30 6hbtr1 STAATT",
    "Friday": "10:30 - 16:30 6h3brm STAATT",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Beatriz Ventura",
    "Sunday": "08:30 - 14:30 6h3brm STAATT",
    "Monday": "11:00 - 17:00 6h3brm STAATT",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Eduardo Ceccaldi",
    "Sunday": "P: 14:00-23:00",
    "Monday": "P: 14:00-23:00",
    "Tuesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "Wednesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "Thursday": "P: 14:00-23:00",
    "Friday": "P: 14:00-23:00",
    "Saturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Verenice Hernandez",
    "Sunday": "N",
    "Monday": "P: 06:00-20:00",
    "Tuesday": "P: 06:00-20:00",
    "Wednesday": "P: 06:00-20:00",
    "Thursday": "P: 06:00-20:00",
    "Friday": "P: 06:00-20:00",
    "Saturday": "N"
  },
  {
    "name": "Melissa M Lopez",
    "Sunday": "N",
    "Monday": "11:00 - 17:00 6h3brm STAATT",
    "Tuesday": "P: 07:00-17:00",
    "Wednesday": "11:00 - 17:00 6h3brm STAATT",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Lianna Padilla",
    "Sunday": "P: 19:00-05:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "P: 05:00-15:00",
    "Thursday": "P: 06:00-16:00",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Briseyda Salgado",
    "Sunday": "P: 08:00-18:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Francisco J Pelayo-Bibian",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "P: 05:00-18:00",
    "Wednesday": "P: 05:00-18:00",
    "Thursday": "P: 05:00-18:00",
    "Friday": "P: 05:00-17:00",
    "Saturday": "P: 05:00-15:00"
  },
  {
    "name": "Liseth Reynoso",
    "Sunday": "N",
    "Monday": "10:00 - 18:00 7.4h3brm STAATT",
    "Tuesday": "N",
    "Wednesday": "10:00 - 18:00 7.4h3brm STAATT",
    "Thursday": "N",
    "Friday": "10:30 - 16:30 6h3brm STAATT",
    "Saturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Raymond Gonzalez",
    "Sunday": "N",
    "Monday": "P: 06:00-04:00",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Janet Pereda",
    "Sunday": "ARDO",
    "Monday": "P: 05:00-15:30",
    "Tuesday": "11:30 - 17:30 6h3brm STAATT",
    "Wednesday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "Thursday": "12:30 - 18:30 6h3brm STAATT",
    "Friday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "Saturday": "12:30 - 20:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Connie R Acosta",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Natalia A Lozano",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "P: 05:00-17:00",
    "Wednesday": "10:00 - 16:00 6hbtr1 STAATT",
    "Thursday": "P: 05:00-17:00RDO",
    "Friday": "11:00 - 17:00 6h3brm STAATT",
    "Saturday": "08:30 - 16:30 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Marissa Rodriguez",
    "Sunday": "08:30 - 14:30 6h3brm STAATT",
    "Monday": "P: 06:00-16:00",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "09:00 - 15:00 6hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jonathan A Hernandez",
    "Sunday": "11:00 - 17:00 6h3brm STAATT",
    "Monday": "P: 06:00-16:00",
    "Tuesday": "P: 06:00-17:00",
    "Wednesday": "N",
    "Thursday": "P: 06:00-17:00",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Rebekah Mendoza",
    "Sunday": "10:00 - 19:00 8hpod2 LSADMN  LSDC",
    "Monday": "N",
    "Tuesday": "06:30 - 15:30 8hpod2 LSADMN  LSDC",
    "Wednesday": "N",
    "Thursday": "06:30 - 15:30 8hpod2 LSADMN  LSDC",
    "Friday": "ARDO",
    "Saturday": "06:30 - 15:30 8hpod2 LSADMN  LSDC"
  },
  {
    "name": "Tatiana J Hill",
    "Sunday": "09:00 - 15:00 6hbtr1 STAATT",
    "Monday": "10:30 - 18:00 6.9hbtr2 STAATT",
    "Tuesday": "N",
    "Wednesday": "10:30 - 18:00 6.9hbtr2 STAATT",
    "Thursday": "P: 05:00-18:00",
    "Friday": "N",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Ashley P Munoz",
    "Sunday": "11:00 - 18:30 6.9h3brm STAATT",
    "Monday": "12:30 - 18:30 6h3brm STAATT",
    "Tuesday": "N",
    "Wednesday": "12:30 - 18:30 6h3brm STAATT",
    "Thursday": "N",
    "Friday": "12:30 - 18:30 6h3brm STAATT",
    "Saturday": "13:00 - 21:00 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Samantha R Quimpo",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "12:30 - 18:30 6h3brm STAATT",
    "Saturday": "13:30 - 21:30 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Emely P Ramos",
    "Sunday": "12:30 - 18:30 6hvend STAATT",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "13:30 - 21:30 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Philiciti Rito",
    "Sunday": "10:00 - 16:00 6hvend STAATT",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "09:00 - 15:00 6hvend STAATT",
    "type": "standAtt"
  },
  {
    "name": "Helen Ceron",
    "Sunday": "N",
    "Monday": "ARDO",
    "Tuesday": "P: 05:00-16:00RDO",
    "Wednesday": "P: 05:00-16:00RDO",
    "Thursday": "P: 05:00-16:00RDO",
    "Friday": "ARDO",
    "Saturday": "N"
  },
  {
    "name": "Desiree Rangel",
    "Sunday": "10:00 - 16:00 6hbtr2 STAATT",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "12:30 - 18:30 6h3brm STAATT",
    "Friday": "12:30 - 18:30 6h3brm STAATT",
    "Saturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Sean M Dirat",
    "Sunday": "N",
    "Monday": "P: 06:00-17:00",
    "Tuesday": "P: 06:00-17:00",
    "Wednesday": "10:30 - 16:30 6h3brm STAATT",
    "Thursday": "N",
    "Friday": "11:00 - 17:00 6hbtr1 STAATT",
    "Saturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Lesley F Quito",
    "Sunday": "N",
    "Monday": "P: 06:00-18:00",
    "Tuesday": "11:30 - 17:30 6h3brm STAATT",
    "Wednesday": "10:30 - 16:30 6h3brm STAATT",
    "Thursday": "P: 06:00-18:00",
    "Friday": "P: 06:00-18:00",
    "Saturday": "10:30 - 18:00 6.9hneep STAATT",
    "type": "standAtt"
  },
  {
    "name": "Marilyn Lopez",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "N"
  },
  {
    "name": "Shelly X Cabrera",
    "Sunday": "12:30 - 18:30 6h3brm STAATT",
    "Monday": "12:30 - 18:30 6h3brm STAATT",
    "Tuesday": "A - PDO",
    "Wednesday": "12:30 - 18:30 6h3brm STAATT",
    "Thursday": "A",
    "Friday": "P: 08:00-20:30",
    "Saturday": "12:00 - 20:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jonathan M Cedeno",
    "Sunday": "12:30 - 18:30 6hbtr1 STAATT",
    "Monday": "12:30 - 18:30 6h3brm STAATT",
    "Tuesday": "A",
    "Wednesday": "12:30 - 18:30 6h3brm STAATT",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Elizabeth M Landero",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "P: 11:00-00:00",
    "Friday": "P: 10:00-23:00",
    "Saturday": "P: 10:00-23:00RDO"
  },
  {
    "name": "Christopher J Lechuga",
    "Sunday": "08:30 - 14:30 6h3brm STAATT",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "08:00 - 16:00 7.4h3brm LDFOH",
    "type": "standAtt"
  },
  {
    "name": "Deisy A Ponce",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "ARDO"
  },
  {
    "name": "Christopher Mcelroy",
    "Sunday": "P: 15:00-03:00",
    "Monday": "P: 15:00-03:00",
    "Tuesday": "P: 15:00-03:00",
    "Wednesday": "P: 15:00-03:00",
    "Thursday": "P: 15:00-03:00",
    "Friday": "P: 15:00-03:00",
    "Saturday": "P: 15:00-03:00"
  },
  {
    "name": "Nicole Toubia",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "13:00 - 21:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Andrew Avila",
    "Sunday": "A",
    "Monday": "A - PDO",
    "Tuesday": "A",
    "Wednesday": "A - PDO",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "11:00 - 19:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Desirae Valdez A Valdez",
    "Sunday": "P: 07:00-18:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "P: 07:00-20:00",
    "Saturday": "12:00 - 19:30 6.9hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michelle Gonzalez Nambo",
    "Sunday": "P: 07:00-17:30",
    "Monday": "N",
    "Tuesday": "A",
    "Wednesday": "N",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "11:00 - 18:30 6.9h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Celine C Merino",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "11:00 - 18:30 6.9h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Katherine A Resnik",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "12:00 - 19:30 6.9h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jonathan Saavedra",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "P: 12:00-02:00"
  },
  {
    "name": "Marissa Tovar",
    "Sunday": "A",
    "Monday": "P: 06:30-14:30",
    "Tuesday": "P: 06:30-14:30",
    "Wednesday": "P: 06:30-14:30",
    "Thursday": "P: 06:30-13:30",
    "Friday": "A",
    "Saturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Dedrick R Hayes",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Kimberly E Cortez",
    "Sunday": "N",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "ADNS"
  },
  {
    "name": "Julia M Lopez",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "12:00 - 18:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michael A Mazadiego",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Julie M Moreno",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Erick G Villarreal",
    "Sunday": "A",
    "Monday": "P: 13:00-04:00",
    "Tuesday": "P: 13:00-04:00",
    "Wednesday": "P: 13:00-04:00",
    "Thursday": "P: 13:00-04:00",
    "Friday": "A",
    "Saturday": "ADNS"
  },
  {
    "name": "Sheyla A Alarcon",
    "Sunday": "P: 13:00-23:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "12:00 - 18:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Elder R Jerez",
    "Sunday": "P: 08:00-20:00",
    "Monday": "N",
    "Tuesday": "P: 08:00-20:00",
    "Wednesday": "P: 08:00-20:00",
    "Thursday": "P: 08:00-20:00",
    "Friday": "P: 08:00-20:00",
    "Saturday": "08:00 - 14:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Donald C Lamont-jones",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "10:00 - 16:00 6hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jerry Leyva",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "12:00 - 18:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Camila J Flores",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "08:00 - 14:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Donald E Holland",
    "Sunday": "A",
    "Monday": "P: 06:00-16:00",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "P: 06:00-16:00",
    "Friday": "A",
    "Saturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Emily A Martin",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Cynthia T Romero",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "A",
    "Wednesday": "N",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Benjamin G Hayes",
    "Sunday": "P: 09:00-21:30",
    "Monday": "N",
    "Tuesday": "A",
    "Wednesday": "P: 10:30-23:00",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "P: 10:00-22:30"
  },
  {
    "name": "Angelica M Palacio",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "N",
    "Wednesday": "A - PDO",
    "Thursday": "A - PDO",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Michelle A Zelaya",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "A",
    "Wednesday": "N",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Marvina M Hubbard",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Cherry Lynne F Aguilar",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Brenda L Cervantes",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "David A Nguyen",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "A"
  },
  {
    "name": "Russel M Santiago",
    "Sunday": "A",
    "Monday": "P: 13:00-00:00",
    "Tuesday": "A",
    "Wednesday": "P: 13:00-00:00",
    "Thursday": "N",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Michelle M Garcia",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "William T Bastin",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Jammiee Y Benbo",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Tiphani Clark",
    "Sunday": "P: 16:00-04:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "P: 16:00-04:00",
    "Friday": "P: 16:00-04:00",
    "Saturday": "P: 16:00-04:00"
  },
  {
    "name": "Sean R Gonzalez",
    "Sunday": "N",
    "Monday": "A",
    "Tuesday": "P: 15:00-01:00",
    "Wednesday": "A",
    "Thursday": "P: 15:00-01:00",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Joseph M Martinez",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "P: 14:00-00:00",
    "Wednesday": "A",
    "Thursday": "P: 14:00-00:00",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Andrew J Montes",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Aleksandra I Murga Higueros",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "A",
    "Saturday": "A - PDO"
  },
  {
    "name": "Yosselin L Pineda",
    "Sunday": "N",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Axel O Rosa Rodriguez",
    "Sunday": "N",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Gerald R Ruiz",
    "Sunday": "A",
    "Monday": "P: 08:00-17:00",
    "Tuesday": "P: 08:00-17:00",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Kadie D Williams",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A",
    "type": "leadFOH"
  },
  {
    "name": "Jaylin R Young",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Krissia L Flores",
    "Sunday": "A",
    "Monday": "P: 15:00-01:00",
    "Tuesday": "N",
    "Wednesday": "P: 15:00-01:00",
    "Thursday": "N",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "LeRoy M Ellis III",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Julian O Sanabria Hernandez",
    "Sunday": "P: 07:30-19:30",
    "Monday": "A",
    "Tuesday": "A - PDO",
    "Wednesday": "P: 07:30-19:30",
    "Thursday": "A",
    "Friday": "P: 07:30-19:30",
    "Saturday": "P: 07:30-19:30"
  },
  {
    "name": "Jon-Eric D Williams",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "P: 03:00-15:00",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Bryan A Delgado",
    "Sunday": "N",
    "Monday": "P: 05:00-17:00",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Alejandra Martinez-Rivera",
    "Sunday": "P: 03:00-13:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "P: 21:00-07:00"
  },
  {
    "name": "Heriberto Sanchez",
    "Sunday": "P: 05:00-15:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "P: 05:00-15:00"
  },
  {
    "name": "Irene Correa",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "P: 04:00-14:00",
    "Saturday": "P: 04:00-14:00"
  },
  {
    "name": "Yvonne S Guerrero",
    "Sunday": "P: 03:00-17:00",
    "Monday": "P: 03:00-14:00 - PDO",
    "Tuesday": "P: 03:00-16:00",
    "Wednesday": "N - PDO",
    "Thursday": "P: 03:00-16:00",
    "Friday": "P: 03:00-16:00",
    "Saturday": "P: 03:00-17:00"
  },
  {
    "name": "Giancarlo De Leon",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "A",
    "Friday": "P: 06:00-14:00",
    "Saturday": "N"
  },
  {
    "name": "Adrian J Gonzalez",
    "Sunday": "P: 04:00-13:00",
    "Monday": "P: 04:00-13:00",
    "Tuesday": "N - PDO",
    "Wednesday": "N - PDO",
    "Thursday": "P: 04:00-13:00",
    "Friday": "N - PDO",
    "Saturday": "N - PDO"
  },
  {
    "name": "Jorge L Mac",
    "Sunday": "P: 05:00-13:00",
    "Monday": "N",
    "Tuesday": "P: 05:00-13:00",
    "Wednesday": "A",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Vanessa Fierro",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "P: 10:00-20:00",
    "Saturday": "N"
  },
  {
    "name": "Allison A Norris",
    "Sunday": "P: 02:00-16:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "13:00 - 15:00 2hfood FDMEET",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Anna C Lucas",
    "Sunday": "N",
    "Monday": "P: 04:30-14:30",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "P: 04:30-14:30",
    "Saturday": "N"
  },
  {
    "name": "Christopher O Sahagun",
    "Sunday": "P: 05:00-19:00",
    "Monday": "N",
    "Tuesday": "P: 15:00-03:00",
    "Wednesday": "P: 15:00-03:00",
    "Thursday": "P: 16:00-04:00",
    "Friday": "P: 12:30-01:00",
    "Saturday": "11:30 - 18:30 6.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Isabel D Carranza",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "P: 07:00-17:00",
    "Saturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Raul Cossio",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Mario Ortiz",
    "Sunday": "P: 03:00-13:00",
    "Monday": "P: 07:00-17:00",
    "Tuesday": "P: 07:00-17:00",
    "Wednesday": "P: 07:00-17:00",
    "Thursday": "P: 07:00-17:00",
    "Friday": "P: 07:00-17:00",
    "Saturday": "P: 03:00-13:00"
  },
  {
    "name": "Patricia Huelgas",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "P: 06:00-16:00",
    "Saturday": "N"
  },
  {
    "name": "Samantha R Maldonado",
    "Sunday": "P: 11:00-09:00",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "P: 07:00-08:00"
  },
  {
    "name": "Lexus M Lopez",
    "Sunday": "A",
    "Monday": "P: 18:00-06:00",
    "Tuesday": "P: 20:00-06:00",
    "Wednesday": "P: 18:00-06:00",
    "Thursday": "P: 20:00-06:00",
    "Friday": "N",
    "Saturday": "N"
  },
  {
    "name": "Angie N Quintanilla",
    "Sunday": "A - PDO",
    "Monday": "N",
    "Tuesday": "A",
    "Wednesday": "N",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Sean T Trainotti",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "A"
  },
  {
    "name": "Jeanette n Hardy",
    "Sunday": "ARDO",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Kassandra Godinez Sandoval",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "A - PDO",
    "Saturday": "A"
  },
  {
    "name": "Doniece L McGee",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "N",
    "Saturday": "A"
  },
  {
    "name": "Antoinette M Paris",
    "Sunday": "A",
    "Monday": "N",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "N",
    "Friday": "N",
    "Saturday": "A"
  },
  {
    "name": "Precious D Hernandez",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Heather Barton",
    "Sunday": "11:00 - 18:30 6.9h3brm STAATT",
    "Monday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "12:30 - 18:30 6h3brm STAATT",
    "Friday": "10:30 - 18:30 7.4h3brm STAATT",
    "Saturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Bruce B Barber",
    "Sunday": "P: 05:00-16:00",
    "Monday": "P: 05:00-16:00",
    "Tuesday": "P: 05:00-16:00",
    "Wednesday": "P: 05:00-16:00",
    "Thursday": "P: 05:00-16:00",
    "Friday": "P: 05:00-16:00",
    "Saturday": "P: 05:00-16:00"
  },
  {
    "name": "Juan Contreras",
    "Sunday": "",
    "Monday": "",
    "Tuesday": "",
    "Wednesday": "",
    "Thursday": "",
    "Friday": "",
    "Saturday": ""
  },
  {
    "name": "Autumn M Denham",
    "Sunday": "",
    "Monday": "",
    "Tuesday": "",
    "Wednesday": "",
    "Thursday": "",
    "Friday": "",
    "Saturday": ""
  },
  {
    "name": "Melanie J Garcia",
    "Sunday": "",
    "Monday": "",
    "Tuesday": "",
    "Wednesday": "",
    "Thursday": "",
    "Friday": "",
    "Saturday": ""
  },
  {
    "name": "Destinee Gorrocino",
    "Sunday": "P: 04:00-16:00",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "P: 04:00-16:00",
    "Thursday": "P: 04:00-16:00",
    "Friday": "P: 04:00-16:00",
    "Saturday": "P: 04:00-16:00"
  },
  {
    "name": "Dajonique L Howard",
    "Sunday": "ADNS",
    "Monday": "ADNS",
    "Tuesday": "ADNS",
    "Wednesday": "ADNS",
    "Thursday": "ADNS",
    "Friday": "ADNS",
    "Saturday": "ADNS"
  },
  {
    "name": "Andrew J Martinez",
    "Sunday": "N",
    "Monday": "N",
    "Tuesday": "P: 06:00-17:00",
    "Wednesday": "P: 06:00-17:00",
    "Thursday": "P: 06:00-17:00",
    "Friday": "P: 06:00-17:00",
    "Saturday": "P: 06:00-17:00"
  },
  {
    "name": "Jose D Ortega",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "A",
    "Wednesday": "A",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  },
  {
    "name": "Arlene R Ruiz",
    "Sunday": "",
    "Monday": "",
    "Tuesday": "",
    "Wednesday": "",
    "Thursday": "",
    "Friday": "",
    "Saturday": ""
  },
  {
    "name": "Derrell B Smith",
    "Sunday": "",
    "Monday": "",
    "Tuesday": "",
    "Wednesday": "",
    "Thursday": "",
    "Friday": "",
    "Saturday": ""
  },
  {
    "name": "Luis M Swann",
    "Sunday": "A",
    "Monday": "A",
    "Tuesday": "N",
    "Wednesday": "N",
    "Thursday": "A",
    "Friday": "A",
    "Saturday": "A"
  }
]